import { ApiError } from "./baseQuery";

function invalidateOnSuccess<T extends string>(...tags: T[]) {
    return (_result: unknown, error: unknown) => (error ? [] : tags);
}

// Deliberately shows no toast: this runs on every failed attempt, background refetches included, and only the
// call site knows whether the user is waiting for the result or already sees an error state.
function transformErrorResponse(err: unknown, fallbackMessage: string): ApiError {
    const message = (err as Partial<ApiError> | undefined)?.message;
    return { message: typeof message === "string" && message ? message : fallbackMessage };
}

export { invalidateOnSuccess, transformErrorResponse };
